// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// Third-party libraries
import "./libs";

import Rails from "@rails/ujs";
import * as ActiveStorage from "@rails/activestorage";
import "channels";
import "stylesheets/application.scss";

// Import shared
import "packs/shared/index.js";

// Imports all view js
import "packs/views/sbsa/index.js";
import "packs/views/snapscan/index.js";

import "packs/views/snapscan/index.js";

Rails.start();
ActiveStorage.start();
